module.exports = __webpack_public_path__ + "img/tip_matchmaking.23302210.png";